import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS, SERVICES } from "@/lib/data";
import { Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-char text-bone/90">
            <div className="container-wide py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                {/* Brand */}
                <div>
                    <Link to="/" className="block mb-4">
                        <img src={BRAND.logoUrlFooter} alt={BRAND.name} className="h-24 md:h-28 w-auto object-contain" />
                    </Link>
                    <p className="text-sm leading-relaxed text-bone/60 max-w-sm">
                        Custom homes, renovations and extensions on the Central Coast. Over 30 years of hands-on experience.
                    </p>
                    <div className="mt-6 flex gap-3">
                        <a href={BRAND.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2 border border-bone/20 hover:bg-clay hover:border-clay transition-colors" data-testid="footer-instagram">
                            <Instagram size={16} />
                        </a>
                        <a href={BRAND.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="p-2 border border-bone/20 hover:bg-clay hover:border-clay transition-colors" data-testid="footer-facebook">
                            <Facebook size={16} />
                        </a>
                    </div>
                </div>

                {/* Navigation */}
                <div>
                    <h4 className="overline text-clay mb-5">Navigation</h4>
                    <ul className="space-y-3 text-sm">
                        {NAV_LINKS.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    className="text-bone/80 hover:text-clay transition-colors"
                                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Services */}
                <div>
                    <h4 className="overline text-clay mb-5">Services</h4>
                    <ul className="space-y-3 text-sm">
                        {SERVICES.map((s) => (
                            <li key={s.slug}>
                                <Link
                                    to={`/#${s.slug}`}
                                    className="text-bone/80 hover:text-clay transition-colors"
                                    data-testid={`footer-service-${s.slug}`}
                                >
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact */}
                <div>
                    <h4 className="overline text-clay mb-5">Get in Touch</h4>
                    <ul className="space-y-3 text-sm text-bone/80">
                        <li className="flex items-start gap-3">
                            <Mail size={14} className="mt-1 text-clay" />
                            <a href={`mailto:${BRAND.email}`} className="hover:text-clay transition-colors" data-testid="footer-email">
                                {BRAND.email}
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin size={14} className="mt-1 text-clay" />
                            <span>Central Coast, NSW</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <Clock size={14} className="mt-1 text-clay" />
                            <span>{BRAND.hours}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-bone/10">
                <div className="container-wide py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-bone/50">
                    <div>
                        ABN {BRAND.abn} · {BRAND.licenceLabel}
                    </div>
                    <div>© {new Date().getFullYear()} {BRAND.legal} trading as {BRAND.name}. All Rights Reserved.</div>
                </div>
            </div>
        </footer>
    );
}
